import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React from 'react';
import * as S from './CameraNotAuthorized.style';
export default function CameraNotAuthorized() {
    return (_jsxs(S.CameraNotAuthorized, { children: [_jsx(S.AccessDeniedText, { children: "\uCE74\uBA54\uB77C \uAD8C\uD55C\uC774 \uD544\uC694\uD569\uB2C8\uB2E4." }), _jsx(S.AccessDeniedText, { children: "\uC124\uC815\uC5D0\uC11C \uCE74\uBA54\uB77C \uAD8C\uD55C\uC744 \uCF1C\uC8FC\uC138\uC694." })] }));
}
